const amount = value => value && typeof value === 'object' ? Number(value.amount_minor) / 100 : Number(value);

export const invoiceCreditRows = invoice => [
  ['Paid by package', amount(invoice?.package_credit ?? invoice?.membership_service_usable_credit)],
  ['Paid by subscription', amount(invoice?.subscription_credit ?? invoice?.subscription_service_usable_price)],
].filter(([, value]) => Number.isFinite(value) && value > 0);
